import { render, staticRenderFns } from "./JoinUsIndex.vue?vue&type=template&id=3f92a6da&scoped=true"
import script from "./JoinUsIndex.vue?vue&type=script&lang=js"
export * from "./JoinUsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92a6da",
  null
  
)

export default component.exports